<template>
	<div id="centerWidth" :style="{'height':windowHeight+'px'}" style="overflow: auto;" @scroll="scrollEvent">
		<div class="centerWidth">
			<div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span>根据科目选专业</span>
			</div>

			<section class="gaokao-content">
				<div class="my-title">根据科目选专业</div>

				<div class="major" v-if="isFlag" style="padding-bottom: 50px;">
					<div class="head_top flex wrap">
						<p class="flexCenter shou" :class="item.isSelect ? 'on' : ''" @click="onTab(index,1)"
							v-for="(item, index) in tabList.firstList" :key="index">
							{{item.name}}
							<i class="el-icon-check"></i>
						</p>
					</div>
					<div class="head_top flex wrap">
						<p class="flexCenter shou" :class="item.isSelect ? 'on' : ''" @click="onTab(index,2)"
							v-for="(item, index) in tabList.secondList" :key="index">
							{{item.name}}
							<i class="el-icon-check"></i>
						</p>
					</div>
					<p>请选择三门学科</p>
					<button type="button" class="shou" @click="GoNext">下一步</button>
				</div>

				<div class="ahead_top flex float" v-if="!isFlag">
					<div class="ahead_left flexFloat">
						<div class="laa" style="padding-left: 30px;width:195px;height: 195px;" id="myChartYuan"></div>
						<div class="lab" style="padding-right: 30px;">
							<p>最优组合方案（点击修改组合）ps：请勿选择重复项</p>
							<div class="ladiv flexFloat">
								<div class="la_select flexCenter">
									<el-select v-model="firstObj" placeholder="请选择" @change="SelectChange">
										<el-option v-for="item in aoptions" :key="item.value" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</div>
								<div class="la_select flexCenter">
									<el-select v-model="secondObj" placeholder="请选择" @change="SelectChange">
										<el-option v-for="item in aoptions" :key="item.value" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</div>
								<div class="la_select flexCenter">
									<el-select v-model="thirdObj" placeholder="请选择" @change="SelectChange">
										<el-option v-for="item in aoptions" :key="item.value" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</div>
							<p>综合匹配率越高，代表更多的意向专业和院校可填报</p>
						</div>
					</div>

					<div class="ahead_you flexFloat">
						<!-- <div class="ayou_left" id="myChart"></div> -->
						<div class="ayou_left" style="width: 270px;height: 270px;">
							<canvas id="myCancas" style="width: 270px;height: 270px;"></canvas>
						</div>
						<div class="ayou_right">
							<p>科学关联性</p>
							<h1>{{result||'弱'}}</h1>
							<p style="color: #666666;">分为强、中、弱三个等级，关联性越高越利于学习</p>
						</div>
					</div>
				</div>
				<div v-if="!isFlag">
					<article class="major-share">
						<div class="major-share-con">
							<div class="share-li">
								<p>按院校搜索:</p>
								<input v-model="schoolName" placeholder="请输入院校名称" />
							</div>
							<div class="share-li">
								<p>选择首选科目:</p>
								<el-select class="sjWidth" v-model="firstSubject" placeholder="请选择首选科目">
									<el-option v-for="item in options" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</div>
							<div class="share-li">
								<p>按专业搜索:</p>
								<input v-model="majorName" placeholder="请输入专业名称" />
							</div>
							<div class="share-li">
								<p>输入选考科目:</p>
								<input v-model="subjectName" placeholder="请输入选考科目" />
							</div>
						</div>
						<div class="major-btn01"><button class="gaokao-btn" v-on:click="GetList(1)">搜索</button></div>
					</article>

					<!-- 2.23 -->
					<section class="system">
						<article class="table">
							<hgroup class="flex">
								<p>院校名称</p>
								<p>专业名称</p>
								<p style="width: 170px;">包含专业</p>
								<p>首选科目</p>
								<p style="width: 320px;">选科科目要求</p>
								<p>备注</p>
							</hgroup>
							<ul>
								<li class="flex zhong" v-for="(item, index) in CollegeList" :key="index">
									<div class="lia">
										<!--  @click="yuanTo(item.CollegesName)" -->
										<p class="shou pttlan" @click="getCollegesList(item.CollegesName)">
											{{item.CollegesName}}
										</p>
									</div>
									<div class="lia">
										<!-- @click="zhuanTo(item.Id)" -->
										<p class="shou pttlan" @click="getNewProfessionalTypeList(item.MajorName)">
											{{item.MajorName}}
										</p>
									</div>
									<div class="lia" style="width: 170px;">
										<p>{{item.ContainMajor}}</p>
									</div>
									<div class="lia">
										<p>{{item.PreferredSubject}}</p>
									</div>
									<div class="lia" style="width: 320px;">
										<p>{{item.RequirementsSubjects}}</p>
									</div>
									<div class="lia">
										<p>{{item.Remarks}}</p>
									</div>
								</li>
							</ul>
						</article>
						<!-- <div class="flex xend pageDiv">
							<el-pagination background layout="prev, pager, next" :page-size="pageSize"
								@current-change="GetPageList" :current-page="page" :total="totleNum"></el-pagination>
						</div> -->
					</section>
					<!--
                2.23
                <article class="major-list">
                    <ul>
                        <li v-for="(item, index) in CollegeList" :key="index">
                            <div class="major-li01">
                                <div class="major-li-btn">
                                    <p>{{ item.CollegesName }}</p>
                                </div>
                                <div class="major-li01-right">
                                    <p>
                                        <span>首选科目:</span>
                                        <span>{{ item.PreferredSubject }}</span>
                                    </p>
                                    <p>
                                        <span>专业代码:</span>
                                        <span>{{ item.MajorCode }}</span>
                                    </p>
                                    <p>
                                        <span>选考科目要求:</span>
                                        <span>{{ item.RequirementsSubjects }}</span>
                                    </p>
                                    <p>
                                        <span>院校代码:</span>
                                        <span>{{ item.CollegesCode }}</span>
                                    </p>
                                    <p class="zy-width">
                                        <span>专业名称:</span>
                                        <span>{{ item.MajorName }}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="major-li02">
                                <p class="major-txt01">包含专业:</p>
                                <p class="major-txt02">{{ item.ContainMajor }}</p>
                                <p class="major-more" @click="moreBtn(item.Id)">更多</p>
                            </div>
                            <div class="major-li02">
                                <p class="major-txt01">备注:</p>
                                <p class="major-txt04">{{ item.Remarks }}</p>
                            </div>
                            <div class="major-more-con" v-show="item.isMore">{{ item.ContainMajor }}</div>
                        </li>
                    </ul>
                    <div class="flex xend major-page">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :page-size="pageSize"
                            @current-change="GetPageList"
                            :current-page="page"
                            :total="totleNum"
                        ></el-pagination>
                    </div>
                </article> -->
				</div>
			</section>
		</div>

		<!-- 院校 -->
		<aside class="popup flex zhong center" v-if="isYxPop">
			<div class="aside_pop" style="cursor:pointer;">
				<div class="aside_height" v-if="CurrCollegeList.length>0">
					<ul>
						<li v-for="(item, index) in CurrCollegeList" :key="index" @click="yuanTo(item.CollegesName)">
							{{item.CollegesName}}
						</li>
					</ul>
				</div>
				<div class="ptend_gao" v-else>
					<div class=" ptend_div">
						<img src="../../../image/empty.png" />
						<p>暂无数据</p>
					</div>
				</div>
				<div class="aside_btn flex zhong center"><button class="zhun_btn" @click="isYxPop = false">关闭</button>
				</div>
			</div>
		</aside>
		<!-- 专业 -->
		<aside class="popup flex zhong center" v-if="isZyPop">
			<div class="aside_pop" style="cursor:pointer;">
				<div class="aside_height" v-if="ProfessionalList.length>0">
					<ul>
						<li v-for="(item, index) in ProfessionalList" :key="index" @click="zhuanTo(item.Id)">
							{{item.Name}}
						</li>
					</ul>
				</div>
				<div class="ptend_gao" v-else>
					<div class=" ptend_div">
						<img src="../../../image/empty.png" />
						<p>暂无数据</p>
					</div>
				</div>
				<div class="aside_btn flex zhong center"><button class="zhun_btn" @click="isZyPop = false">关闭</button>
				</div>
			</div>
		</aside>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				// 院校
				isYxPop: false,
				yxList: [{
					Name: '5656'
				}, {
					Name: '5656'
				}],
				// 专业
				isZyPop: false,
				zyList: [{
					MajorName: '5656'
				}, {
					MajorName: '5656'
				}],
				tableList: [{}, {}, {}, {}, {}],
				// 2.23
				options: [],
				firstSubject: '',
				// 列表
				list: [],
				schoolName: '',
				subjectName: '',
				majorName: '',
				totleNum: 0,
				page: 1,
				pageSize: 10,
				CollegeList: [],
				tabList: {
					firstList: [{
						id: 1,
						name: '物理',
						isSelect: false
					}, {
						id: 2,
						name: '历史',
						isSelect: false
					}],
					secondList: [{
						id: 3,
						name: '化学',
						isSelect: false
					}, {
						id: 4,
						name: '生物',
						isSelect: false
					}, {
						id: 5,
						name: '政治',
						isSelect: false
					}, {
						id: 6,
						name: '地理',
						isSelect: false
					}, {
						id: 7,
						name: '技术',
						isSelect: false
					}]
				},
				isFlag: true,
				aoptions: [{
						value: 1,
						label: '物理'
					},
					{
						value: 2,
						label: '历史'
					},
					{
						value: 3,
						label: '化学'
					},
					{
						value: 4,
						label: '生物'
					},
					{
						value: 5,
						label: '政治'
					},
					{
						value: 6,
						label: '地理'
					},
					{
						value: 7,
						label: '技术'
					}
				],
				avalue: '',
				windowHeight: document.documentElement.clientHeight,
				firstObj: 0,
				secondObj: 0,
				thirdObj: 0,
				searchList: [{
						name: '物理,化学,生物',
						value: '0.96',
						rusult: '强'
					},
					{
						name: '物理,化学,地理',
						value: '0.96',
						rusult: '强'
					},
					{
						name: '物理,化学,历史',
						value: '0.97',
						rusult: '中'
					},
					{
						name: '物理,化学,政治',
						value: '0.97',
						rusult: '中'
					},
					{
						name: '物理,化学,技术',
						value: '0.96',
						rusult: '强'
					},
					{
						name: '物理,生物,历史',
						value: '0.95',
						rusult: '弱'
					},
					{
						name: '物理,生物,地理',
						value: '0.94',
						rusult: '中'
					},
					{
						name: '物理,生物,政治',
						value: '0.96',
						rusult: '弱'
					},
					{
						name: '物理,生物,技术',
						value: '0.94',
						rusult: '中'
					},
					{
						name: '生物,化学,地理',
						value: '0.74',
						rusult: '强'
					},
					{
						name: '生物,化学,历史',
						value: '0.74',
						rusult: '中'
					},
					{
						name: '生物,化学,政治',
						value: '0.74',
						rusult: '中'
					},
					{
						name: '化学,技术,历史',
						value: '0.72',
						rusult: '弱'
					},
					{
						name: '物理,技术,地理',
						value: '0.93',
						rusult: '弱'
					},
					{
						name: '生物,化学,技术',
						value: '0.73',
						rusult: '弱'
					},
					{
						name: '化学,技术,地理',
						value: '0.72',
						rusult: '弱'
					},
					{
						name: '生物,技术,历史',
						value: '0.68',
						rusult: '弱'
					},
					{
						name: '化学,技术,政治',
						value: '0.72',
						rusult: '弱'
					},
					{
						name: '物理,技术,政治',
						value: '0.94',
						rusult: '弱'
					},
					{
						name: '物理,技术,历史',
						value: '0.94',
						rusult: '弱'
					},
					{
						name: '生物,技术,政治',
						value: '0.69',
						rusult: '弱'
					},
					{
						name: '生物,技术,地理',
						value: '0.68',
						rusult: '弱'
					},
					{
						name: '政治,地理,技术',
						value: '0.54',
						rusult: '中'
					},
					{
						name: '政治,历史,技术',
						value: '0.54',
						rusult: '中'
					},
					{
						name: '历史,地理,技术',
						value: '0.53',
						rusult: '中'
					},
					{
						name: '历史,政治,地理',
						value: '0.38',
						rusult: '强'
					},
					{
						name: '历史,政治,化学',
						value: '0.73',
						rusult: '中'
					},
					{
						name: '历史,政治,生物',
						value: '0.61',
						rusult: '中'
					},
					{
						name: '历史,地理,物理',
						value: '0.94',
						rusult: '中'
					},
					{
						name: '历史,地理,化学',
						value: '0.73',
						rusult: '中'
					},
					{
						name: '历史,政治,物理',
						value: '0.95',
						rusult: '中'
					},
					{
						name: '历史,地理,生物',
						value: '0.62',
						rusult: '中'
					},
					{
						name: '政治,地理,物理',
						value: '0.94',
						rusult: '弱'
					},
					{
						name: '政治,地理,化学',
						value: '0.73',
						rusult: '中'
					},
					{
						name: '政治,地理,生物',
						value: '0.64',
						rusult: '弱'
					}
				],
				result: '',
				resultValue: 0,
				myChartRate: null,
				myChartRadar: null,
				canvasRadar: null,
				canvasCtx: null,
				canvasList: [],
				canvasText: [],
				isLoad: false,
				ProfessionalList: [],
				CurrCollegeList: []
			};
		},
		watch: {
			windowHeight(val) {
				const that = this;
				console.log('实时屏幕高度：', val, that.windowHeight);
			}
		},
		mounted() {
			const that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.windowHeight = window.fullHeight;
				})();
			};
			this.GetFirstMajor();
			this.GetList(1);
			if (this.$route.query.key) {
				this.$api.reduceUserCount({
					key: this.$route.query.key
				});
			} else {
				this.$router.back(-1);
			}
		},
		methods: {
			scrollEvent(e) {
				var that = this;
				var scrollBottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
				if (scrollBottom < 10) {
					console.log('翻页');
					var page = that.page;
					page++;
					that.GetList(page);
				}
			},
			SelectChange: function() {
				console.log(this.thirdObj);
				var that = this;
				var name = '';
				var canvasText = [];
				var firstStr = '';
				var secondStr = '';
				var thirdStr = '';
				that.aoptions.map(a => {
					if (a.value === that.firstObj) {
						// name += name.length > 0 ? ',' + a.label : a.label;
						canvasText.push(a.label);
						firstStr = a.label;
					}
					if (a.value === that.secondObj) {
						secondStr = a.label;
						canvasText.push(a.label);
					}
					if (a.value === that.thirdObj) {
						thirdStr = a.label;
						canvasText.push(a.label);
					}
				});
				name = firstStr + ',' + secondStr + ',' + thirdStr;
				that.searchList.map(a => {
					if (a.name.indexOf(firstStr) != -1 && a.name.indexOf(secondStr) != -1 && a.name.indexOf(
							thirdStr) != -1) {
						that.result = a.rusult;
						that.resultValue = a.value;
					}
				});
				var options = that.myChartRate.getOption();
				// options.series[0].center[0] = parseFloat(that.resultValue) * 100 + '%';
				// options.series[0].center[1] = ((1 - parseFloat(that.resultValue)) * 100).toFixed(0) + '%';
				options.graphic[0].elements[0].style.text = parseFloat(that.resultValue) * 100 + '%';
				options.series[0].data[0].value = parseFloat(that.resultValue) * 100;
				options.series[0].data[1].value = parseFloat((1 - parseFloat(that.resultValue * 100) / 100).toFixed(
					2)) * 100;
				that.myChartRate.setOption(options);
				that.canvasText = canvasText;
				// 清空画布
				that.canvasCtx.clearRect(0, 0, that.canvasRadar.width, that.canvasRadar.height);
				that.DrawPolygon(that.canvasList.length);
				that.DrawText(that.canvasList);
				setTimeout(function() {
					that.DrawRegion();
				}, 300);
			},
			// 选好专业
			GoNext: function() {
				var that = this;
				var selectNum = 0;
				var name = '';
				var canvasText = [];
				var firstStr = '';
				var secondStr = '';
				var thirdStr = '';
				that.tabList.firstList.map(a => {
					if (a.isSelect) {
						selectNum++;
						that.firstObj = a.id;
						name = a.name;
						canvasText.push(a.name);
						firstStr = a.name;
					}
				});
				that.tabList.secondList.map(a => {
					if (a.isSelect) {
						that.secondObj = that.secondObj > 0 ? that.secondObj : a.id;
						that.thirdObj = that.secondObj > 0 ? a.id : that.thirdObj;
						selectNum++;
						name += ',' + a.name;
						canvasText.push(a.name);
						secondStr = secondStr.length > 0 ? secondStr : a.name;
						thirdStr = a.name;
					}
				});
				if (selectNum < 3) {
					that.$util.showError('请选择三门科目');
					return;
				}
				that.searchList.map(a => {
					if (a.name.indexOf(firstStr) != -1 && a.name.indexOf(secondStr) != -1 && a.name.indexOf(
							thirdStr) != -1) {
						that.result = a.rusult;
						that.resultValue = a.value;
					}
					// if (a.name === name) {
					// 	that.result = a.rusult;
					// 	that.resultValue = a.value;
					// }
				});
				this.isFlag = false;
				that.canvasText = canvasText;
				that.$nextTick(function() {
					that.SetCanvas();
					that.drawLineB();
				});
			},
			drawLineB() {
				var that = this;
				// 基于准备好的dom，初始化echarts实例
				this.myChartRate = this.$echarts.init(document.getElementById('myChartYuan'));
				var radius = [];
				radius.push(parseFloat(that.resultValue) * 100 + '%');
				radius.push(((1 - parseFloat(that.resultValue)) * 100).toFixed(0) + '%');
				var dataList = [];
				dataList.push({
					value: parseFloat(that.resultValue),
					name: ''
				});
				dataList.push({
					value: parseFloat((1 - parseFloat(that.resultValue * 100) / 100).toFixed(2)),
					name: ''
				});
				radius = ['60%', '90%'];
				// 绘制图表
				this.myChartRate.setOption({
					color: ['#a3ceff', '#3171ff'],
					tooltip: {
						trigger: 'item'
					},
					graphic: {
						// 图形中间文字
						type: 'text',
						left: 'center',
						top: 'center',
						style: {
							text: parseFloat(that.resultValue) * 100 + '%',
							textAlign: 'center',
							fill: '#000',
							fontSize: 24
						}
					},
					legend: {
						top: '0%',
						left: 'center'
					},
					series: [{
						type: 'pie',
						radius: radius,
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '40',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: dataList
					}]
				});
			},
			// 2.13
			zhuanTo(id) {
				this.isZyPop = false;
				window.open(`${window.location.origin}${window.location.pathname}#/majorinfo?Id=${id}`);
				// this.$router.push({
				// 	path: '/majorinfo',
				// 	query: {
				// 		Id: id
				// 	}
				// });
			},
			yuanTo(name) {
				window.open(`${window.location.origin}${window.location.pathname}#/schoolinfo?schoolname=${name}`);
				// this.$router.push({
				// 	path: '/schoolinfo',
				// 	query: {
				// 		schoolname: name
				// 	}
				// });
			},
			// 以上 2.23
			onTab(index, type) {
				var that = this;
				var name = '';
				var firstStr = '';
				var secondStr = '';
				var thirdStr = '';
				// var canvasText = [];
				if (type === 1) {
					var firstList = that.tabList.firstList;
					firstList.forEach(a => {
						a.isSelect = false;
						name = a.name;
						// canvasText.push(a.name);
					});
					firstList[index].isSelect = true;
					firstStr = firstList[index].name;
				} else {
					var selectNum = 0;
					var secondList = that.tabList.secondList;
					secondList.map(a => {
						if (a.isSelect) {
							selectNum++;
							name += ',' + a.name;
							// canvasText.push(a.name);
							secondStr = secondStr.length > 0 ? secondStr : a.name;
							thirdStr = a.name;
						}
					});
					var isSelect = !secondList[index].isSelect;
					if (selectNum >= 2 && isSelect) {
						that.$util.showError('最多只能选两个');
						return;
					} else {
						secondList[index].isSelect = !secondList[index].isSelect;
					}
					that.secondList = secondList;
				}

				that.searchList.map(a => {
					if (a.name.indexOf(firstStr) != -1 && a.name.indexOf(secondStr) != -1 && a.name.indexOf(
							thirdStr) != -1) {
						that.result = a.rusult;
						that.resultValue = a.value;
					}

					// if (a.name === name) {
					// 	that.result = a.rusult;
					// 	that.resultValue = a.value;
					// }
				});
			},
			// 个人中心
			goMyCenter() {
				this.$router.push('/myIndex');
			},
			// 查看更多
			moreBtn(id) {
				var that = this;
				var list = that.CollegeList;
				for (var i = 0; i < list.length; i++) {
					if (list[i].Id === id) {
						list[i].isMore = !list[i].isMore;
					}
				}
				that.CollegeList = list;
			},
			// 上一步
			goTestb() {
				this.$router.push('/gktestb');
			},
			// 下一步
			goTestd() {
				this.$router.push('/gktestd');
			},
			// 获取首选科目
			GetFirstMajor: function() {
				var that = this;
				that.$api.HtppRequest(
					'SystemData/GetFirstMajor',
					'GET', {},
					function(res) {
						console.log('获取首选科目');
						console.log(res);
						if (res.flag) {
							var list = res.list;
							var newList = [];
							for (var i = 0; i < list.length; i++) {
								newList.push({
									value: list[i],
									label: list[i]
								});
							}
							that.options = newList;
						}
					},
					function(res) {}
				);
			},
			// 获取列表
			GetList: function(page) {
				var that = this;
				if (that.isLoad) {
					return;
				}
				that.isLoad = true;
				const loading = this.$loading({
					lock: true
				});
				// Name院校名称  PreferredSubject首选科目  MajorName专业名称  RequirementsSubjects选科科目
				that.$api.HtppRequest(
					'WebsiteSet/RecentlySectionRequirementsByParams?CollegeName=' + that.schoolName +
					'&PreferredSubject=' + that.firstSubject + '&MajorName=' + that.majorName +
					'&RequirementsSubjects=' + that.subjectName + '&pageSize=10&page=' + page,
					'GET', {},
					function(res) {
						console.log('获取列表');
						console.log(res);
						if (res.code === 0) {
							var list = res.data;
							var newList = page > 1 ? that.CollegeList : [];
							for (var i = 0; i < list.length; i++) {
								newList.push({
									Id: list[i].Id,
									CityCode: list[i].CityCode,
									CollegesCode: list[i].CollegesCode,
									CollegesName: list[i].CollegesName,
									MajorCode: list[i].MajorCode,
									MajorName: list[i].MajorName,
									ContainMajor: list[i].ContainMajor,
									PreferredSubject: list[i].PreferredSubject,
									RequirementsSubjects: list[i].RequirementsSubjects,
									Remarks: list[i].Remarks,
									CreateTime: list[i].CreateTime,
									isMore: false
								});
							}
							that.CollegeList = newList;
							that.page = page;
							// that.totleNum = res.totle;
							console.log(that.CollegeList);
						}
						that.isLoad = false;
						loading.close();
					},
					function(err) {
						console.log(err);
						that.isLoad = false;
						loading.close();
					}
				);
			},
			// 获取其他页
			GetPageList: function(val) {
				var that = this;
				that.GetList(val);
				console.log(`当前页: ${val}`);
			},
			// ============================= 绘制雷达图===================
			// 初始化canvas
			SetCanvas: function() {
				var that = this;
				that.canvasRadar = document.getElementById('myCancas');
				// 设置宽高
				that.canvasRadar.height = 270;
				that.canvasRadar.width = 270;
				that.canvasCtx = that.canvasRadar.getContext('2d');
				var textList = [];
				that.aoptions.map(a => {
					textList.push(a.label);
				});
				that.canvasList = textList;
				// 清空画布
				that.canvasCtx.clearRect(0, 0, that.canvasRadar.width, that.canvasRadar.height);
				that.DrawPolygon(textList.length);
				that.DrawText(textList);
				that.DrawRegion();
			},
			// 绘制多边形 num多边形数量
			DrawPolygon: function(num) {
				var that = this;
				that.canvasCtx.save();
				that.canvasCtx.strokeStyle = '#a3ceff'; // 多边形颜色
				// 画多边形
				that.canvasCtx.beginPath();
				var center = that.canvasRadar.width / 2; // 中心点位置，x y 是一样的
				var currR = center - 50; // 初始化圆半径，50为文字空间
				var mAngle = Math.PI * 2 / num; // 获取最小角度
				// 开始计算并画多边形，每一个点旋转mAngle角度
				// that.canvasCtx.moveTo(0, 0);
				for (var i = 0; i < num; i++) {
					var x = center + currR * Math.cos(mAngle * i);
					var y = center + currR * Math.sin(mAngle * i);
					that.canvasCtx.lineTo(x, y);
				}
				that.canvasCtx.closePath(); // 结束当前绘画路径
				that.canvasCtx.stroke(); // 完成当前绘画
			},
			// 绘制文本 几个边就对应几个顶点，每个顶点显示一个名称
			DrawText: function(textList) {
				var that = this;
				that.canvasCtx.save();
				var center = that.canvasRadar.width / 2; // 中心点位置，x y 是一样的
				var currR = center - 40; // 初始化圆半径，50为文字空间
				var mAngle = Math.PI * 2 / textList.length; // 获取最小角度
				var fontSize = currR / 12; // 设置字体大小
				that.canvasCtx.font = fontSize;
				that.canvasCtx.fillStyle = '#666'; // 文字颜色
				// 开始计算并画多边形，每一个点旋转mAngle角度
				for (var i = 0; i < textList.length; i++) {
					var x = center + currR * Math.cos(mAngle * i);
					var y = center + currR * Math.sin(mAngle * i);
					that.canvasCtx.lineTo(x, y);
					// 第一象限
					if (mAngle * i >= 0 && mAngle * i <= Math.PI / 2) {
						that.canvasCtx.fillText(textList[i], x, y + fontSize);
					}
					// 第二象限
					else if (mAngle * i > Math.PI / 2 && mAngle * i <= Math.PI) {
						that.canvasCtx.fillText(textList[i], x - (textList[i].length * fontSize), y + fontSize);
					}
					// 第三象限
					else if (mAngle * i > Math.PI && mAngle * i <= Math.PI * 3 / 2) {
						that.canvasCtx.fillText(textList[i], x - (textList[i].length * fontSize), y + fontSize);
					}
					// 第四象限
					else {
						that.canvasCtx.fillText(textList[i], x, y + fontSize);
					}
				}
				that.canvasCtx.restore(); // 结束文本绘制
			},
			// 顶点连线
			DrawRegion: function() {
				var that = this;
				var selectTextList = that.canvasText;
				var textList = that.canvasList;
				that.canvasCtx.save();
				that.canvasCtx.beginPath();
				that.canvasCtx.strokeStyle = 'red'; // 连线颜色
				var center = that.canvasRadar.width / 2; // 中心点位置，x y 是一样的
				var currR = center - 50; // 初始化圆半径，50为文字空间
				var mAngle = Math.PI * 2 / textList.length; // 获取最小角度
				selectTextList.map(a => {
					var index = 0;
					// 找到当前文本的位置
					for (var i = 0; i < textList.length; i++) {
						if (a === textList[i]) {
							index = i;
						}
					}
					// 计算点位置
					var x = center + currR * Math.cos(mAngle * index);
					var y = center + currR * Math.sin(mAngle * index);
					that.canvasCtx.lineTo(x, y);
				});
				that.canvasCtx.closePath(); // 结束当前绘画路径
				that.canvasCtx.fillStyle = '#a3ceff'; // 填充当前区域颜色
				that.canvasCtx.fill(); // 执行填充
				that.canvasCtx.restore();
			},
			// 获取专业列表
			getNewProfessionalTypeList(name) {
				var that = this;
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				// that.zyList = [];
				that.$api.HtppRequest(
					'SystemData/NewProfessionalTypeList?page=1&pageSize=99&name=' + name,
					'GET', {},
					function(res) {
						console.log('获取列表', res);
						if (res.code === 0) {
							that.isZyPop = true;
							that.ProfessionalList = res.data.list;
						}
						loading.close();
					},
					function(err) {
						loading.close();
						console.log(err);
					}
				);
			},
			// 获取院校列表
			getCollegesList(name) {
				var that = this;
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				// that.yxList = [];
				that.$api.HtppRequest(
					'SystemData/GetCollegesDataList',
					'POST', {
						page: 1,
						size: 99,
						colleges: name
					},
					function(res) {
						console.log('获取列表', res);
						if (res.flag) {
							that.isYxPop = true;
							that.CurrCollegeList = res.list;
						}
						loading.close();
					},
					function(err) {
						loading.close();
						console.log(err);
					}
				);
			}
		}
	};
</script>

<style scoped>
	.aside_height li {
		border-bottom: solid 1px #eeeeee;
		padding: 14px 0;
		text-indent: 1em;
		font-size: 14px;
		color: #666666;
	}

	.aside_height {
		height: 320px;
		overflow-y: auto;
		border-radius: 6px;
		border: solid 1px #eeeeee;
	}

	.zhun_btn.on {
		background-color: #005371;
	}

	.zhun_btn {
		width: 120px;
		height: 40px;
		background-color: #666;
		border-radius: 4px;
		font-size: 14px;
		color: #fff;
		line-height: 40px;
		margin-right: 20px;
		display: block;
		cursor: pointer;
	}

	.zhun_btn:last-child {
		margin-right: 0;
	}

	.aside_btn .zhun_btn {
		background-color: #333;
		border: solid 1px #333;
	}

	.aside_btn .zhun_btn:first-child {
		background-color: #fff;
		color: #333;
		border: solid 1px #333;
	}

	.aside_btn {
		margin-top: 40px;
	}

	.aside_box {
		width: 70%;
		margin: 0 10px;
	}

	.aside_div {
		width: 90%;
		margin: 0 auto;
	}

	.aside_pop {
		width: 520px;
		border-radius: 10px;
		background-color: #fff;
		padding: 50px 20px 20px 20px;
	}

	/* aside_pop */

	.ayou_right h1 {
		width: 145px;
		height: 40px;
		background: url(../../../image/san/aq.png) no-repeat left top;
		background-size: 100% 100%;
		text-align: center;
		line-height: 40px;
		font-size: 30px;
		color: #3171ff;
		margin: 30px 0;
	}

	.ayou_right p {
		font-size: 14px;
		color: #3171ff;
	}

	.ayou_right {
		padding-right: 32px;
	}

	.ayou_left {
		width: 300px;
		height: 230px;
	}

	.la_select {
		width: 100px;
		margin: 30px 0;
	}

	.la_select /deep/.el-input__inner {
		border: solid 1px #0079fe;
	}

	.lab p {
		font-size: 13px;
		color: #666;
	}

	.lab {
		width: calc(100% - 228px);
	}

	.laa {
		width: 228px;
		height: 195px;
	}

	.ahead_left {
		border-right: solid 1px #fff;
	}

	.ahead_left,
	.ahead_you {
		padding: 60px 0;
		width: 50%;
	}

	.ahead_top {
		background-color: #eaeaea;
		margin-bottom: 25px;
		margin-top: 30px;
	}

	/* 12 */

	.lia p {
		padding: 0 10px;
		box-sizing: border-box;
		font-size: 14px;
		text-align: center;
		color: #666666;
		position: relative;
	}

	.lia::after {
		content: '';
		width: 1px;
		height: 300%;
		background-color: #e6e6e6;
		position: absolute;
		right: 0;
		top: -30px;
		z-index: 0;
	}

	.lia {
		padding: 20px 0;
		width: calc(100% / 6);
		position: relative;
	}

	.lia:last-child::after {
		width: 0px;
	}

	.img_box img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.img_box {
		border-radius: 6px;
		width: 96px;
		height: 68px;
		margin: 0 auto;
		overflow: hidden;
	}

	/* img_box */

	.pageDiv {
		overflow: hidden;
		margin-top: 20px;
	}

	.table li p {
		font-size: 14px;
		text-align: center;
	}

	.table li {
		border-bottom: solid 1px #e6e6e6;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table ul {
		overflow: hidden;
	}

	.table hgroup p:last-child {
		border-right: none;
	}

	.table hgroup p {
		font-size: 14px;
		background-color: #eaeaea;
		border-right: solid 1px #e6e6e6;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table {
		overflow: hidden;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
	}

	.system {
		overflow: hidden;
		padding: 20px;
	}

	/* safety */

	/* 2.23 */
	.major>button {
		width: 200px;
		height: 40px;
		background-color: #444444;
		font-size: 14px;
		color: #fff;
		background-color: #444444;
		display: block;
		margin: 40px auto 0 auto;
		border-radius: 4px;
	}

	.major>p {
		text-align: center;
		font-size: 16px;
		color: #005270;
		padding: 40px 0;
	}

	.major {
		padding-bottom: 50px;
	}

	.head_top p {
		width: 190px;
		height: 40px;
		border-radius: 4px;
		border: solid 1px #dddddd;
		font-size: 14px;
		color: #000;
		box-sizing: border-box;
		margin-top: 20px;
		margin-right: 20px;
	}

	.head_top p:nth-child(5n + 5) {
		margin-right: 0;
	}

	.head_top p.on {
		background-color: #005270;
		color: #fff;
	}

	.head_top p.on i {
		color: #fff;
	}

	.head_top p i {
		color: transparent;
		margin-left: 10px;
		display: inline-block;
	}

	.head_top {
		padding-top: 20px;
	}

	.major {
		padding: 0 64px;
	}

	/* major */

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
		cursor: pointer;
	}

	.gaokao-nav span:hover {
		opacity: 0.7;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
	}

	/* major-share */
	.major-share {
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #eaeaea;
		display: flex;
		margin: 20px auto 30px auto;
		padding: 30px 0;
	}

	.major-share-con {
		width: 75%;
		height: auto;
		overflow: ;
		display: flex;
		flex-wrap: wrap;
	}

	.share-li {
		width: 50%;
		display: flex;
		align-items: center;
		/* justify-content: center; */
		margin: 10px 0;
	}

	.share-li p {
		font-size: 14px;
		color: #333;
		width: 100px;
		text-align: right;
		margin-right: 20px;
	}

	.share-li input {
		width: 270px;
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		display: block;
		border-radius: 5px;
		background-color: #fff;
		color: #333;
		font-size: 14px;
	}

	.share-li input::-webkit-input-placeholder {
		color: #999;
	}

	.share-li input:-moz-placeholder {
		color: #999;
	}

	.share-li input:-ms-input-placeholder {
		color: #999;
	}

	.sjWidth {
		width: 270px;
	}

	.major-btn01 {
		width: 25%;
		display: flex;
		align-items: flex-end;
	}

	.major-btn01 button {
		margin: 10px auto;
		width: 120px;
	}

	/* major-list */
	.major-list {
		width: 100%;
		height: auto;
		margin-top: 15px;
	}

	.major-list ul {
		width: 100%;
		height: auto;
	}

	.major-list ul li {
		border: 1px solid #eee;
		width: 100%;
		height: auto;
		padding: 20px 30px;
		margin-bottom: 20px;
		position: relative;
	}

	.major-li01 {
		width: 100%;
		height: auto;
		display: flex;
		align-items: center;
	}

	.major-li-btn {
		width: 20%;
	}

	.major-li-btn p {
		width: 170px;
		height: 33px;
		line-height: 33px;
		text-align: center;
		background-color: #333;
		font-size: 16px;
		color: #fff;
		border-radius: 50px;
	}

	.major-li01-right {
		width: 80%;
		display: flex;
		flex-wrap: wrap;
	}

	.major-li01-right p {
		width: 25%;
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}

	.major-li01-right p span {
		font-size: 15px;
		color: #999;
	}

	.major-li01-right p span:last-child {
		color: #333;
	}

	.major-li01-right p:nth-child(3) {
		width: 50%;
	}

	.major-li01-right .zy-width {
		width: 75%;
	}

	.major-li02 {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.major-li02 p {
		font-size: 14px;
	}

	.major-txt01 {
		width: 75px;
		color: #999;
	}

	.major-txt02 {
		width: calc(100% - 120px);
		color: #333;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.major-more {
		width: 45px;
		color: #333;
		text-align: right;
		cursor: pointer;
	}

	.major-txt04 {
		color: #333;
	}

	.major-more-con {
		position: absolute;
		width: 98%;
		height: auto;
		background: rgba(0, 0, 0, 0.7);
		padding: 20px;
		font-size: 15px;
		color: #fff;
		left: 1%;
		bottom: 0;
		border-radius: 5px;
		margin-bottom: -14px;
		z-index: 1;
	}

	.major-more-con::after {
		position: absolute;
		content: '';
		right: 0;
		top: 0;
		width: 0;
		height: 0;
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
		border-bottom: 14px solid rgba(0, 0, 0, 0.7);
		margin-top: -14px;
		margin-right: 24px;
	}

	.major-page {
		margin-bottom: 30px;
	}
</style>
